export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/legal.f5d6a82b.svg","height":68,"width":69,"blurWidth":0,"blurHeight":0};